

const inkDashboard = {
  controller: 'DashboardController',
  template: require('./dashboard.template.html')
};

angular
  .module('inkfinder')
  .component('inkDashboard', inkDashboard);



// WEBPACK FOOTER //
// ./components/dashboard/dashboard.component.js